import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>Al-Wustaa Charitable Foundation</p>
      <p>SAVE LIFE SAVE HUMANITY - ومن أحياها فكأنما أحيا الناس جميعا</p>
      <p>Contact us: alwustaacharitablefoundation3@gmail.com | Follow us on <a href="https://x.com/AlwustaaFound_n" target="_blank" rel="noopener noreferrer">X</a>
      
      <a href="https://www.facebook.com/share/17X3L8Gj3R/" target="_blank" rel="noopener noreferrer">Facebook</a>

       <a href="https://www.instagram.com/alwustaacharitablefoundation/" target="_blank" rel="noopener noreferrer">Instagram</a>

      <a href="https://www.youtube.com/@AL-WUSTAACHARITABLEFOUNDATION" target="_blank" rel="noopener noreferrer">Youtube</a>

      <a href="https://www.tiktok.com/@alwustaafoundation?lang=en" target="_blank" rel="noopener noreferrer">Tiktok</a></p>
      
    </footer>
  );
}

export default Footer;